import React, { forwardRef } from "react";
import "./CreateCharacterSection.css";

const CreateCharacterSection = forwardRef((props, ref) => {
  return (
    <section
      ref={ref}
      className="create-character-section"
      style={{
        backgroundImage: "url('/mines.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark overlay */}
      <div className="overlay"></div>

      <div className="character-content">
        {/* Dice Image */}
        <div className="character-image">
          <img src="/dice.png" alt="Roll Dice" />
        </div>

        {/* Text & Button */}
        <div className="character-text">
          <p>
            Roll new characters and discover the hero that fits your playstyle.
            Mint the character you want directly using <strong>$DERP</strong>.
            Complete Daily Quests to earn experience and level up your characters.
          </p>

          <a href="https://app.quest.derpe.xyz"
          target="_blank" className="character-button">
            Create a Character
          </a>
        </div>
      </div>
    </section>
  );
});

export default CreateCharacterSection;
